module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/高速打件机.44e6d24b.jpg";